module.exports = __webpack_public_path__ + "img/prt0006.prt.6e3236ca.jpg";